<script setup lang="ts">
/**
 * Schlichtes Layout ohne Seitenleiste: für Seiten, die auch ohne Server funktionieren müssen
 * (Offline-Übungsbereich) - die Verwaltungsleiste würde dort nur Aufrufe starten, die ins Leere laufen.
 */
</script>

<template>
  <div class="standalone">
    <main class="standalone-main">
      <slot />
    </main>
  </div>
</template>

<style scoped>
.standalone { min-height: 100vh; background: #f1f5f9; }
.standalone-main { max-width: 56rem; margin: 0 auto; padding: 1rem; }
</style>
